import { render, staticRenderFns } from "./bVideo.vue?vue&type=template&id=59e0de20&scoped=true"
import script from "./bVideo.vue?vue&type=script&lang=js"
export * from "./bVideo.vue?vue&type=script&lang=js"
import style0 from "./bVideo.vue?vue&type=style&index=0&id=59e0de20&prod&lang=less&scoped=true"
import style1 from "./bVideo.vue?vue&type=style&index=1&id=59e0de20&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e0de20",
  null
  
)

export default component.exports